<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M2.85798 15.337C4.12035 15.337 5.14369 14.3137 5.14369 13.0513C5.14369 11.789 4.12035 10.7656 2.85798 10.7656C1.59561 10.7656 0.572266 11.789 0.572266 13.0513C0.572266 14.3137 1.59561 15.337 2.85798 15.337Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.1431 12.4801C14.4055 12.4801 15.4289 11.4568 15.4289 10.1944C15.4289 8.93204 14.4055 7.90869 13.1431 7.90869C11.8807 7.90869 10.8574 8.93204 10.8574 10.1944C10.8574 11.4568 11.8807 12.4801 13.1431 12.4801Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M15.4302 10.1942V1.23424C15.4298 1.1468 15.4092 1.06064 15.3701 0.982398C15.3312 0.904151 15.2747 0.835904 15.2051 0.782912C15.1356 0.72992 15.0548 0.693595 14.969 0.676737C14.8832 0.659879 14.7947 0.662935 14.7102 0.68567L5.56739 3.22281C5.44657 3.25535 5.33977 3.32663 5.26338 3.42573C5.18699 3.52483 5.14523 3.64626 5.14453 3.77138V13.0514"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.14453 6.76583L15.4302 3.90869"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
